export const TERMS_LINK =
  '/docs/wsplayersTandC.pdf';
export const PRIVACY_LINK = '/docs/wsplayersPP.pdf';
